import React from 'react';

const IconYouTube = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-youtube">
    <title>YouTube</title>
    <rect x="2" y="5" width="20" height="14" rx="4" ry="4" fill="none" stroke="currentColor" />
    <path d="M10 9l5 3-5 3V9z" fill="currentColor" stroke="none" />
  </svg>
);

export default IconYouTube;
